import { render } from "./Aplications-l.vue?vue&type=template&id=a27c8b2c&scoped=true"
const script = {}

import "./Aplications-l.vue?vue&type=style&index=0&id=a27c8b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27c8b2c"]])

export default __exports__